// src/hooks/useCustomerOptions.js
//
// Müşteri seçici (Autocomplete) kullanan form ve modallar için ortak müşteri listesi.
//
// Daha önce bu ekranların her biri açılışta
// `onSnapshot(query(collection(db, "customers"), orderBy("adSoyad", "asc")))`
// çalıştırıyordu. 1300+ müşteride bu, HER modal açılışında 1300+ doküman
// okuması demekti (5 ayrı ekranda aynı sorgu). Bunun yerine `useCachedCollection`
// üzerinden oturum-içi PAYLAŞIMLI cache kullanılır: oturumda hangi modal açılırsa
// açılsın koleksiyon en fazla TTL'de bir okunur.
//
// Sıralama artık sunucuda değil, cache'lenmiş veri üzerinde client tarafında
// yapılır (Türkçe alfabe sırası).

import { useMemo } from 'react';
import useCachedCollection from './useCachedCollection';

export default function useCustomerOptions() {
  const { data, loading, error, refresh } = useCachedCollection('customers');

  const customers = useMemo(
    () => [...data].sort((a, b) => (a.adSoyad || '').localeCompare(b.adSoyad || '', 'tr')),
    [data]
  );

  return { customers, loading, error, refresh };
}
